<nav>
    <ul class="list-group list-group-horizontal">
         @if (this.isAdmin) { 
        <li class="list-group-item">
            <a [routerLink]="'/front/ivatypes'" routerLinkActive="resaltado">{{ 'navbar.ivaTypes' | translate}}</a>
        </li>
        <li class="list-group-item">
            <a [routerLink]="'/front/coins'" routerLinkActive="resaltado">{{'navbar.coins' | translate}}</a>
        </li>
        <li class="list-group-item">
            <a [routerLink]="'/front/taxes'" routerLinkActive="resaltado">{{'navbar.taxes' | translate}}</a>
        </li>
        <li class="list-group-item">
            <a [routerLink]="'/front/discounts'" routerLinkActive="resaltado">{{'navbar.discounts' | translate}}</a>
        </li>
        <li class="list-group-item">
            <a [routerLink]="'/front/enrollment'" routerLinkActive="resaltado">{{'navbar.matricula' | translate}}</a>
        </li>
     
        <li class="list-group-item">
            <a [routerLink]="'/front/administration'" routerLinkActive="resaltado">{{'navbar.administration' | translate}}</a>
        </li>
        <li class="list-group-item">
            <a [routerLink]="'/front/launcher'" routerLinkActive="resaltado">{{'navbar.launcher' | translate}}</a>
        </li>
       }
    </ul>
    <p>{{nameUser()}}</p>
</nav>